import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.40195 3.00294C10.5566 1.00293 13.4443 1.00293 14.599 3.00294L21.9531 15.7512C23.1064 17.751 21.6629 20.2499 19.3555 20.2499H4.64547C2.33751 20.2499 0.893245 17.7514 2.04782 15.7512V15.7512L9.40195 3.00294ZM10.701 3.75292L3.34713 16.5007C2.76994 17.5004 3.49153 18.7499 4.64547 18.7499H19.3555C20.5081 18.7499 21.2305 17.5008 20.6538 16.5006L13.2999 3.75292C12.7226 2.75293 11.2783 2.75293 10.701 3.75292ZM11.2505 16.2521C11.2505 15.8379 11.5863 15.5021 12.0005 15.5021H12.0075C12.4217 15.5021 12.7575 15.8379 12.7575 16.2521V16.2601C12.7575 16.6743 12.4217 17.0101 12.0075 17.0101H12.0005C11.5863 17.0101 11.2505 16.6743 11.2505 16.2601V16.2521Z"
        fill={colorValue}
      />
      <path
        d="M12.0004 6.25375C14.8156 6.25375 12.0004 14.6226 12.0004 14.6226C12.0004 14.6226 9.18523 6.25375 12.0004 6.25375Z"
        fill={colorValue}
      />
    </svg>
  );
};
